<template>
	<div class="relative-position q-pt-xl" v-if="courses.length > 0">
		<div class="custom-container">
			<div class="row">
				<div class="col-12 text-h6 components-title">
					{{ $t('keep_watching') }}
				</div>
			</div>

			<div class="row q-col-gutter-md" v-if="ispage !== 'home'">
				<q-carousel
					v-model="slide"
					swipeable
					animated
					padding
					arrows
					infinite
					keep-alive
					transition-prev="slide-right"
					prev-icon="fal fa-angle-left"
					transition-next="slide-left"
					next-icon="fal fa-angle-right"
					control-color="grey-7"
					class="no-shadow full-width"
					height="auto"
				>
					<q-carousel-slide
						:name="index + 1"
						class="column no-wrap"
						v-for="(page, index) in paginatedCourses"
						:key="`p${index}`"
					>
						<div class="row q-col-gutter-md">
							<div class="col-3" v-for="(course, index) in page" :key="`i${index}`">
								<course
									:course="course"
									:content="course"
									@favorite="toggleFavorite"
									@like="toggleLike"
									@review="toggleReviews"
								/>
							</div>
						</div>
					</q-carousel-slide>
				</q-carousel>
			</div>

			<div class="row q-col-gutter-md q-mx-md q-mt-xs" v-if="ispage === 'home'">
				<div class="col-3" v-for="(course, index) in courses" :key="`i${index}`">
					<course
						:course="course"
						:content="course"
						@favorite="toggleFavorite"
						@like="toggleLike"
						@review="toggleReviews"
					/>
				</div>

				<div class="col-3">
					<q-card
						class="full-height shadow-transition cursor-pointer card-empty"
						:class="class_hover"
						@mouseover="class_hover = 'shadow-5'"
						@mouseleave="class_hover = ''"
						@click="$router.push({ name: 'courses' })"
					>
						<q-card-section class="absolute-center full-width text-center">
							<p class="q-mt-sm text-body1">
								{{ $t('see_all_content') }}
							</p>
							<q-btn flat color="primary" icon="fas fa-arrow-right" />
						</q-card-section>
					</q-card>
				</div>
			</div>
		</div>

		<q-dialog v-model="show_reviews">
			<user-reviews module="courses" :moduleData="course_to_review" />
		</q-dialog>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</div>
</template>

<script>
import Course from 'components/courses/desktop/Course'
import UserReviews from 'components/shared/desktop/UserReviews'
// Composables
import useFavoriteModule from 'src/composables/useFavoriteModule'
import useLikeModule from 'src/composables/useLikeModule'

export default {
	name: 'HomeKeepWatchingCourses',

	components: {
		course: Course,
		'user-reviews': UserReviews,
	},

	data() {
		return {
			courses: [],
			loading: false,
			slide: 1,
			class_hover: '',
			ispage: '',
			show_reviews: false,
			course_to_review: null,
		}
	},

	computed: {
		paginatedCourses() {
			let chunks = []
			let i = 0
			let n = this.courses.length

			while (i < n) {
				chunks.push(this.courses.slice(i, (i += 4)))
			}
			return chunks
		},
	},

	methods: {
		loadCourses() {
			this.loading = true

			let data = {
				page_type: this.ispage,
			}

			this.$axios
				.get(
					`/etraining_courses/group_trainings/group_training_keep_watching/?${this.$qs.stringify(
						data
					)}`
				)
				.then((response) => {
					this.courses = response.data
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		async toggleFavorite(id) {
			try {
				this.loading = true
				await this.favoriteCourse('courses', this.courses, 'favorited', id)
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},

		async toggleLike(id) {
			try {
				this.loading = true
				await this.likeCourse('courses', this.courses, 'liked', id)
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},

		toggleReviews(id) {
			let obj = this.courses.find((obj) => obj.id === id)
			this.course_to_review = obj
			this.show_reviews = true
		},
	},

	created() {
		this.ispage = this.$route.name
		this.loadCourses()
	},

	setup() {
		const favoriteCourse = useFavoriteModule()
		const likeCourse = useLikeModule()

		return {
			favoriteCourse,
			likeCourse,
		}
	},
}
</script>

<style lang="scss" scoped>
.q-carousel {
	background-color: inherit;
}
</style>
